module.exports = __webpack_public_path__ + "static/product01-c22c8bd1e3977e59faa33c09f2357cab.jpg";